import type { Priority } from '../../enums';
import type { BaseEntityInterface } from './base-entity.interface';

export interface IssueInterface extends BaseEntityInterface {
	assigneeUserId?: number | null;
	/** PD-16475 — company the issue belongs to (stamped at create). */
	companyId?: number | null;
	description?: string | null;
	/** PD-16475 — sanitized rich text; `description` is its plain-text copy. */
	descriptionHtml?: string | null;
	name: string;
	priority?: Priority;
	status?: IssueStatus;
	statusUpdatedDatetime?: Date | null;
	/** PD-13705 — portal (public) user who submitted the issue via the e-commerce portal; null for CRM-created issues. */
	submitterPublicUserId?: number | null;
	type?: IssueType | null;
}

/**
 * PD-16525 — one enum for both workflows. A CRM-created issue uses To-Do /
 * In Progress / Done; a storefront support request (the issue has a portal
 * submitter) uses Needs Reply / In Progress / Waiting on Customer / Resolved /
 * Done. `libs/shared/src/utils/issue-status.ts` holds the per-origin subsets
 * and `IssueService.saveIssue` enforces them. The column is varchar(64), so a
 * new value needs no schema change.
 */
export enum IssueStatus {
	TODO = 'To-Do',
	/** Storefront request: the customer is waiting on the team. */
	NEEDS_REPLY = 'Needs Reply',
	IN_PROGRESS = 'In Progress',
	/** Storefront request: the team replied and is waiting on the customer. */
	WAITING_ON_CUSTOMER = 'Waiting on Customer',
	/** Storefront request: fixed; waiting for the customer to confirm (closes itself after the tenant's waiting period). */
	RESOLVED = 'Resolved',
	DONE = 'Done',
}

export enum IssueType {
	QUESTION = 'Question',
	REQUEST = 'Request',
	PROBLEM = 'Problem',
	ACCOUNTING = 'Accounting',
}
